import React, { FC, ReactElement, useEffect, useState } from 'react';

import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { useMedia } from '@pp/core/src/hooks/useMedia';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';

import { DesktopFooterConnected } from '../../components/DesktopFooterConnected/DesktopFooterConnected';
import { FloatingBetControlsConnected } from '../../components/floatingBetControls/FloatingBetControlsConnected';
import { GameVolumeChannels } from '../../config/sound';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';
import { BalanceFooter } from '../balanceFooter/BalanceFooter';
import { BettingActionCellConnected } from '../cells/bettingActionCell/BettingActionCellConnected';
import { InlineRecentResultsConnected } from '../recentResults/inline/InlineRecentResultsConnected';
import { HideForFloatingBetBoard } from '../tableSheet/mobileTableSheet/HideForFloatingBetBoard';
import { VirtualCashoutKeypadConnected } from '../virtualCashoutKeypad/VirtualCashoutKeypadConnected';
import { VirtualKeypadConnected } from '../virtualKeypad/VirtualKeypadConnected';

import { ChatCellConnected } from './cell/chatCell/ChatCellConnected';
import { StatusBarCellConnected } from './cell/statusBarCell/StatusBarCellConnected';
import { TableSheetCellConnected } from './cell/tableSheetCell/TableSheetCellConnected';
import { VideoCellConnected } from './cell/videoCell/VideoCellConnected';
import { GameGridContextProvider } from './GameGridContext';
import { GameGridWrapperConnected } from './wrapper/GameGridWrapperConnected';

export const GameGridConnected: FC = (): ReactElement => {
  const isShowKeyPad = useHighflyerGameStateSlice.toggleKeypad();
  const audioTrigger = useAudioTrigger(GameVolumeChannels.Background);
  const masterVolume = useSettingsSlice.getMasterChannelValue();
  const [isBGMPlaying, setIsBGMPlaying] = useState<boolean>(false);
  const open = useHighflyerGameStateSlice.toggleStats();
  useEffect(() => {
    setTimeout(() => {
      if (!isBGMPlaying && masterVolume > 0 && audioTrigger) {
        audioTrigger.play({ name: 'musicLoop', loop: true });
        setIsBGMPlaying(true);
      }
    }, 100);
  }, [masterVolume]);

  const isDekstop = useMedia('(min-width: 1024px');

  return (
    <GameGridContextProvider>
      <GameGridWrapperConnected>
        <TableSheetCellConnected />
        <StatusBarCellConnected />
        <VideoCellConnected />
        <ChatCellConnected />
        <BettingActionCellConnected />
        {isShowKeyPad.keypad && <VirtualKeypadConnected betCode={isShowKeyPad.betCode} />}
        {isShowKeyPad.autoCashOut && <VirtualCashoutKeypadConnected betCode={isShowKeyPad.betCode} />}
        {!isDekstop && (
          <HideForFloatingBetBoard open={!open}>
            <BalanceFooter />
          </HideForFloatingBetBoard>
        )}
        <FloatingBetControlsConnected />
        {!isDekstop && <InlineRecentResultsConnected />}
        {isDekstop && <DesktopFooterConnected />}
      </GameGridWrapperConnected>
    </GameGridContextProvider>
  );
};
